import { Stack } from '@mui/material';
import OrderProductItemSkeleton from './OrderProductItemSkeleton';
import { SKELETON_ROW_COUNT } from './orderProductItemSkeleton.constants';

interface OrderProductListSkeletonProps {
  canEditOrder?: boolean;
}

const OrderProductListSkeleton = ({ canEditOrder }: OrderProductListSkeletonProps) => (
  <Stack>
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, row) => (
      <OrderProductItemSkeleton key={row} canEditOrder={canEditOrder} />
    ))}
  </Stack>
);

export default OrderProductListSkeleton;
